import _defineProperty from "@babel/runtime/helpers/defineProperty";
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
import * as ProductClickEvent from '@ori-events/product-click';
import { useCallback } from 'react';
import { useProduct } from "./useProduct";
export var useOnClick = function useOnClick() {
  var _useProduct = useProduct(),
    analyticsData = _useProduct.analyticsData,
    brand = _useProduct.brand,
    code = _useProduct.code,
    image = _useProduct.image,
    name = _useProduct.name,
    currentFormatted = _useProduct.price.currentFormatted,
    onProductBoxClick = _useProduct.onProductBoxClick;
  return useCallback(function (event) {
    var dispatchAnalytics = function dispatchAnalytics() {
      var customEvent = new CustomEvent(ProductClickEvent.Name, {
        detail: _objectSpread({
          products: [{
            itemCode: code,
            formattedPrice: currentFormatted,
            localName: name,
            globalName: '',
            localCategoryName: '',
            globalCategoryName: '',
            localBrandName: brand !== null && brand !== void 0 ? brand : '',
            globalBrandName: '',
            media: image ? [image] : []
          }]
        }, analyticsData)
      });
      window.dispatchEvent(customEvent);
    };
    dispatchAnalytics();
    if (onProductBoxClick) {
      event.preventDefault();
      event.stopPropagation();
      onProductBoxClick();
    }
  }, [analyticsData, brand, code, currentFormatted, image, name, onProductBoxClick]);
};
//# sourceMappingURL=useOnClick.js.map